import React from "react";
import { MdOutlineLuggage } from "react-icons/md";
import { IoBrushSharp, IoChatbubblesOutline } from "react-icons/io5";
import { Button } from "../../atoms/Button/Button";
import { Step } from "./Components";
import { Separator } from "./Components/Separator";
import { Icomoon } from "../../atoms/Icon/Icon";
import "./HowItWorks.scss";
import { useTranslation } from "react-i18next";
import { TrustLink } from "../../molecules/TrustLink/TrustLink";
import { Locale } from "@travellocal/utils";
import { useAppState } from "../../utils";

interface HowItWorks {
  ctaUrl: string;
  dataTrackingId: string;
  locale: Locale;
}

export const HowItWorks = ({ ctaUrl, dataTrackingId, locale }: HowItWorks) => {
  const { t } = useTranslation("ui");
  const { appState } = useAppState();
  const currentLocale = locale || appState?.locale || "en-gb";
  return (
    <div className="step-by-step-wrapper">
      <h3>How it works</h3>
      <div className="steps">
        <Step
          className="step"
          stepNumber={1}
          Icon={<IoBrushSharp size="20px" />}
          description={t(
            "HowItWorks_Step1_Description",
            "Let us know about your trip and we’ll find you the perfect local agent."
          )}
          title={t("HowItWorks_Step1_Title", "Tell us your preferences")}
        />
        <Separator />
        <Step
          className="step"
          stepNumber={2}
          Icon={<IoChatbubblesOutline size="20px" />}
          description={t(
            "HowItWorks_Step2_Description",
            "Collaborate with them to create your perfect itinerary."
          )}
          title={t("HowItWorks_Step2_Title", "Plan with your local agent")}
        />
        <Separator />
        <Step
          className="step"
          stepNumber={3}
          Icon={<MdOutlineLuggage size="20px" />}
          description={
            <>
              {" "}
              {t("HowItWorks_Step3_Description", "")} <TrustLink locale={currentLocale} />.
            </>
          }
          title={t("HowItWorks_Step3_Title", "Book your trip!")}
        />
      </div>
      <Button
        colour="teal"
        icomoonIcon={Icomoon.arrowRight3}
        href={ctaUrl}
        target="_self"
        data-tracking-id={dataTrackingId}
        className="cta-button">
        {t("HowItWorks_CTA", "Get started")}
      </Button>
    </div>
  );
};
